import React from 'react';

import { Wrap, Quantity, Button, Increase, Decrease, Remove } from './styled';

interface QuantitySelectorProps {
    className?: string;
    increaseItemQuantity?: () => void;
    decreaseItemQuantity?: () => void;
    quantity: number;
}

const QuantitySelector = ({
    className,
    quantity,
    increaseItemQuantity,
    decreaseItemQuantity,
}: QuantitySelectorProps): JSX.Element => (
    <Wrap className={className}>
        <Button onClick={decreaseItemQuantity}>
            {quantity === 1 ? (
                <span data-testid="remove-line-item-button">
                    <Remove size="20px" />
                </span>
            ) : (
                <Decrease size="20px" />
            )}
        </Button>

        <Quantity>{quantity}</Quantity>

        <Button onClick={increaseItemQuantity}>
            <Increase size="20px" />
        </Button>
    </Wrap>
);

export default QuantitySelector;
